export default "__VITE_ASSET__0953d718__"